import { Plus, BookOpen } from 'lucide-react';
import type { FloraDossierDocument } from '../../types/flora-ai.types';
import { FloraDossierCard } from '../FloraDossierCard/FloraDossierCard';
import styles from './FloraDossierSection.module.css';

interface FloraDossierSectionProps {
	documents: FloraDossierDocument[];
	onNewConversation?: () => void;
	onOpenLibrary?: () => void;
	onAddDocument?: () => void;
}

export const FloraDossierSection = ({
	documents,
	onNewConversation,
	onOpenLibrary,
	onAddDocument,
}: FloraDossierSectionProps) => {
	return (
		<section className={styles.section}>
			<div className={styles.header}>
				<h2 className={styles.title}>Dossiê da conversa</h2>
				<div className={styles.actions}>
					<button
						type="button"
						className={styles.secondaryButton}
						onClick={onNewConversation}
						aria-label="Nova conversa"
					>
						<Plus className={styles.addIconBtn} strokeWidth={2} />
						<span className={styles.buttonLabel}>Nova conversa</span>
					</button>
					<button
						type="button"
						className={styles.primaryButton}
						onClick={onOpenLibrary}
						aria-label="Abrir biblioteca"
					>
						<BookOpen className={`${styles.addIconBtn} ${styles.libraryIcon}`} strokeWidth={2} />
						<span className={styles.buttonLabel}>Abrir biblioteca</span>
					</button>
				</div>
			</div>
			<div className={styles.track}>
				{documents.map((document) => (
					<FloraDossierCard key={document.id} document={document} />
				))}
				<button
					type="button"
					className={styles.addCard}
					onClick={onAddDocument}
					aria-label="Adicionar documento"
				>
					<Plus className={styles.addIcon} strokeWidth={2} />
					<span>Adicionar</span>
				</button>
			</div>
		</section>
	);
};
